import { record } from 'fp-ts';
import { pipe } from 'fp-ts/function';
import { getTaxExemptionReasons } from '@mews-commander/core/legacy-globalization';
import { TaxExemptionReason } from '@mews-commander/data-access';
import { useCurrentEnterprise } from '@mews-commander/legacy-entities/src/enterprise';
import { useCommanderSelector } from '@mews-commander/utils';

export const useTaxExemptionReasons = () => {
    const { accommodationEnvironmentCode } = useCurrentEnterprise();
    const taxExemptionReasons = useCommanderSelector(getTaxExemptionReasons) as Record<string, TaxExemptionReason>;

    return pipe(
        taxExemptionReasons,
        record.filter(
            (taxExemptionReason) => taxExemptionReason.accountingEnvironmentCode === accommodationEnvironmentCode
        )
    );
};
